import React, { ReactElement, useState, useEffect, useRef } from 'react'
import MapGL, { Source, Layer, MapRef } from 'react-map-gl'
import geohash from 'ngeohash'

import { clusterLayer, clusterCountLayer, unclusteredPointLayer } from './Layers'

export type EventCartChangeData = {
  key: string
  doc_count: number
}

export type Params = {
  data: EventCartChangeData[]
}

const MAPBOX_TOKEN = 'pk.eyJ1IjoiaWNhcm9mYXJtYWNpYXNhcHAiLCJhIjoiY2txdjhxZ2pnMGM3bzJybGZneG83YjlkdyJ9.q1nHq7G314955hZlXo-pAA'

const MapCluster = ({ data }: Params): ReactElement => {
  const [viewport, setViewport] = useState({
    latitude: -14.461139512091087,
    longitude: -61.17362984375048,
    minZoom: 3,
    zoom: 3,
    maxZoom: 12,
    bearing: 0,
    pitch: 0
  })
  const [points, setPoints] = useState<any>()
  const mapRef = useRef<MapRef>(null)

  useEffect(() => {
    if (data) {
      const pointsTemp: any = []
      data.map((row: EventCartChangeData, indexRow: number) => {
        const geoLocation = geohash.decode(row.key)

        for (let index = 0; index < row.doc_count; index++) {
          pointsTemp.push({
            type: 'Feature',
            properties: {
              cluster: false,
              pointId: indexRow
            },
            geometry: {
              type: 'Point',
              coordinates: [
                geoLocation.longitude,
                geoLocation.latitude
              ]
            }
          })
        }
        return pointsTemp
      })

      setPoints({
        features: pointsTemp
      })
    }
  }, [])

  return (
    <>
      <MapGL
        {...viewport}
        width="100%"
        height="420px"
        mapStyle="mapbox://styles/mapbox/dark-v9"
        onViewportChange={setViewport}
        mapboxApiAccessToken={MAPBOX_TOKEN}
        interactiveLayerIds={[clusterLayer.id!]}
        ref={mapRef}
      >
        <Source
          id="earthquakes"
          type="geojson"
          data={points}
          cluster={true}
          clusterMaxZoom={14}
          clusterRadius={50}
        >
          <Layer {...clusterLayer} />
          <Layer {...clusterCountLayer} />
          <Layer {...unclusteredPointLayer} />
        </Source>
      </MapGL>
    </>
  )
}

export default MapCluster
